import FoodMenusModal from './foodMenusModal'

export default FoodMenusModal